export default class Password {
    constructor({
        password,
        passwordConfirm,
    }) {
        this.password = password
        this.passwordConfirm = passwordConfirm
    }
  }